// Brand palette - single source of truth for all colors.
// Import these constants anywhere you need a color value.

/** Royalty - primary purple */
export const royalty = {
  main:    '#5a2f9e',
  light:   '#6b44a8',
  dark:    '#512a8e',
  shade10: '#512a8e',
  shade20: '#48267e',
  shade30: '#3f216f',
  shade40: '#361c5f',
  shade50: '#2d184f',
  shade60: '#24133f',
  shade70: '#1b0e2f',
  shade80: '#120920',
  shade90: '#090510',
  tint10:  '#6b44a8',
  tint20:  '#7b59b1',
  tint30:  '#8c6dbb',
  tint40:  '#9c82c5',
  tint50:  '#ad97cf',
  tint60:  '#bdacd8',
  tint70:  '#cec1e2',
  tint80:  '#ded5ec',
  tint90:  '#efeaf5',
} as const;

/** Alien Parasite - secondary green */
export const alienParasite = {
  main:    '#59fc3c',
  light:   '#6afc50',
  dark:    '#50e336',
  shade10: '#50e336',
  shade20: '#47ca30',
  shade30: '#3eb02a',
  shade40: '#359724',
  shade50: '#2d7e1e',
  shade60: '#246518',
  shade70: '#1b4c12',
  shade80: '#12320c',
  shade90: '#091906',
  tint10:  '#6afc50',
  tint20:  '#7afd63',
  tint30:  '#8bfd77',
  tint40:  '#9bfd8a',
  tint50:  '#acfe9e',
  tint60:  '#bdfeb1',
  tint70:  '#cdfec5',
  tint80:  '#defed8',
  tint90:  '#eeffec',
} as const;

/** Treasured Teal */
export const treasuredTeal = {
  main:    '#50c4b7',
  light:   '#62cabe',
  dark:    '#48b0a5',
  shade10: '#48b0a5',
  shade20: '#409d92',
  shade30: '#388980',
  shade40: '#30766e',
  shade50: '#28625c',
  shade60: '#204e49',
  shade70: '#183b37',
  shade80: '#102725',
  shade90: '#081412',
  tint10:  '#62cabe',
  tint20:  '#73d0c5',
  tint30:  '#85d6cd',
  tint40:  '#96dcd4',
  tint50:  '#a8e2db',
  tint60:  '#b9e7e2',
  tint70:  '#cbede9',
  tint80:  '#dcf3f1',
  tint90:  '#eef9f8',
} as const;

/** Cow's Milk - off-white */
export const cowsMilk = {
  main:    '#f1ece4',
  shade10: '#d9d4cd',
  shade20: '#c1bdb6',
  shade30: '#a9a5a0',
  shade40: '#918e89',
  shade50: '#797672',
  shade60: '#605e5b',
  shade70: '#484744',
  shade80: '#302f2e',
  shade90: '#181817',
  tint10:  '#f2eee7',
  tint20:  '#f4f0e9',
  tint30:  '#f5f2ec',
  tint40:  '#f7f4ef',
  tint50:  '#f8f6f2',
  tint60:  '#f9f7f4',
  tint70:  '#fbf9f7',
  tint80:  '#fcfbfa',
  tint90:  '#fefdfc',
} as const;

/** Utility / neutral colors (not in brand palette, kept for compatibility) */
export const neutral = {
  /** Dark navy used throughout Pricing */
  ink:     '#232347',
  /** Off-white section backgrounds (#f9f9f9) */
  surface: '#f9f9f9',
} as const;

/** Convenience: the brand gradient used on all page wrappers */
export const brandGradient = `linear-gradient(to right, ${royalty.main}, ${alienParasite.main})`;
